import type { ReactNode } from 'react'

import React from 'react'
import { ThemeProvider as NextThemeProvider } from 'next-themes'

export const ThemeProvider = ({ children }: { children: ReactNode }) => (
	<NextThemeProvider
		storageKey='theme'
		attribute='class'
		defaultTheme='system'
		enableSystem
		disableTransitionOnChange
		enableColorScheme
	>
		{children}
	</NextThemeProvider>
)
